import * as PIXI from 'pixi.js';
import GSObject from '../Base/GSObject';
import Global from '../Global';
import Vector from '../Base/Math/Vector';
import LibraryManager from '../Base/Library/LibraryManager';
import { ViewDirection } from '../../GameKit/shared';

export default class Background extends GSObject {
    constructor(gsoParent) {
        super(gsoParent);
        this.level = gsoParent;

        this.columns = [];

        for (let i = 0; i < this.level.size.x; i++) {
            this.columns.push([]);
            for (let j = 0; j < this.level.size.y; j++) {
                this.columns[i].push(0);
            }
        }

        this.blur = true;

        this.pixiContainer = null;
        this.pixiBlurContainer = null;
        this.pixiSprites = [];
        this.pixiMask = null;
    }

    addColumns(amount) {
        const row = [];

        for (let i = 0; i < this.columns[0].length; i++) {
            row.push(0);
        }
        const newColumns = [];
        for (let i = 0; i < Math.abs(amount); i++) {
            newColumns.push(row.slice());
        }
        if (amount > 0) {
            this.columns = this.columns.concat(newColumns);
        } else {
            this.columns = newColumns.concat(this.columns);
        }
        this.requestNewVisuals();
    }

    addRows(amount) {
        const newRow = [];
        for (let i = 0; i < Math.abs(amount); i++) {
            newRow.push(0);
        }
        for (let i = 0; i < this.columns.length; i++) {
            if (amount > 0) {
                this.columns[i] = newRow.concat(this.columns[i]);
            } else {
                this.columns[i] = this.columns[i].concat(newRow);
            }
        }
        this.requestNewVisuals();
    }

    removeColumns(amount) {
        if (amount > 0) this.columns.splice(0, amount);
        else this.columns.splice(this.columns.length + amount, -amount);
        this.requestNewVisuals();
    }

    removeRows(amount) {
        for (let i = 0; i < this.columns.length; i++) {
            if (amount > 0) this.columns[i].splice(0, amount);
            else this.columns[i].splice(this.columns[i].length + amount, -amount);
        }
        this.requestNewVisuals();
    }

    onCreateBody(world) {
        this.requestNewVisuals();
    }

    onCreateVisuals() {
        this.pixiContainer = new PIXI.Container();
        this.level.pixiContainerBackgroundLayer.addChild(this.pixiContainer);

        this.pixiBlurContainer = new PIXI.Container();
        this.pixiContainer.addChild(this.pixiBlurContainer);

        let blurAmount = 0;
        if (this.blur) {
            if (this.level.viewDirection === ViewDirection.Side) {
                blurAmount = 1;
            }
        }

        for (let i = 0; i < this.level.size.x; i++) {
            for (let j = 0; j < this.level.size.y; j++) {
                if (this.columns[i][j]) {
                    const sprite = new PIXI.Sprite(LibraryManager.textures.get(this.columns[i][j]).get());
                    sprite.x = i * Global.NATIVE_BLOCK_SIZE;
                    sprite.y = j * Global.NATIVE_BLOCK_SIZE;
                    sprite.width = Global.NATIVE_BLOCK_SIZE;
                    sprite.height = Global.NATIVE_BLOCK_SIZE;
                    this.pixiBlurContainer.addChild(sprite);
                    this.pixiSprites.push(sprite);
                }
            }
        }
        if (blurAmount > 0) {
            /*
            const blurFilter = new PIXI.filters.BlurFilter();
            blurFilter.blur = blurAmount;
            this.pixiBlurContainer.filters = [blurFilter];
            */
            this.pixiBlurContainer.alpha = 0.5;
        } else {
            this.pixiBlurContainer.alpha = 1;
        }

        this.pixiMask = new PIXI.Graphics();
        this.pixiMask.beginFill(0xffffff);
        this.pixiMask.drawRect(0, 0, this.level.size.x * Global.NATIVE_BLOCK_SIZE, this.level.size.y * Global.NATIVE_BLOCK_SIZE);
        this.pixiContainer.addChild(this.pixiMask);
        this.pixiContainer.mask = this.pixiMask;
    }

    onUpdateVisuals() {}

    onDestroyVisuals() {
        // Destroy all PIXI entities that were introduced by this class.
        this.pixiContainer.destroy();
        for (let i = 0; i < this.pixiSprites; i++) {
            this.pixiSprites[i].destroy();
        }
        this.pixiSprites = [];
        this.pixiMask.destroy();
        this.pixiBlurContainer.destroy();
    }

    serialize() {
        const data = {};
        data.tiles = [];
        for (let j = 0; j < this.level.size.y; j++) {
            for (let i = 0; i < this.level.size.x; i++) {
                data.tiles.push(this.columns[i][j]);
            }
        }
        return data;
    }

    deserialize(data) {
        this.columns = [];
        for (let i = 0; i < this.level.size.x; i++) {
            this.columns.push([]);
            for (let j = 0; j < this.level.size.y; j++) {
                this.columns[i].push(data.tiles[j * this.level.size.x + i]);
            }
        }
    }
}
